import { action } from 'mobx';
import { Collection } from 'core/model';
import UserQuestionModel from './UserQuestionModel';

class UserQuestionCollection extends Collection {
  get model() {
    return UserQuestionModel;
  }

  @action
  populate(rows) {
    const models = rows.map((row, idx) => {
      const model = new UserQuestionModel({ id: String(idx), ...row });
      model.collection = this;
      return model;
    });
    this.models.replace(models);
  }
}

export default UserQuestionCollection;
